import { Component } from '@angular/core';

@Component({
  selector: 'app-controller-inventory-success',
  templateUrl: './controller-inventory-success.component.html',
  styleUrls: ['./controller-inventory-success.component.css']
})
export class ControllerInventorySuccessComponent {

}
